import { HTMLProps } from 'react';
import { useLocation } from 'react-router-dom';

import configsIcon from '../../../../../assets/svgs/configsIcon.svg';
import homeIcon from '../../../../../assets/svgs/homeIcon.svg';
import incluirLead from '../../../../../assets/svgs/incluir-lead.svg';
import logoutIcon from '../../../../../assets/svgs/logoutIcon.svg';
import peoplesIcon from '../../../../../assets/svgs/peoplesIcon.svg';
import profileIcon from '../../../../../assets/svgs/profileIcon.svg';
import { BackLink } from '../../../../../components/navigation/BackLink';
import { NavigationBar } from '../../../../../components/navigation/NavigationBar';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { cm } from '../../../../../libs/cm';
import { PageSubHeaderLeads } from './PageSubHeaderLeads';

type LayoutGestaoLeadsProps = HTMLProps<HTMLDivElement>;

export const LayoutGestaoLeads = ({
  className,
  children,
  ...rest
}: LayoutGestaoLeadsProps) => {
  const classes = cm(
    'tw-flex tw-flex-col tw-bg-white md:tw-flex-row',
    className
  );

  const location = useLocation();

  const isMobile = useMediaQuery('(max-width: 920px)');

  const items = [
    {
      title: 'Início',
      description: 'Painel de Gestão de Leads',
      id: 1,
      url: '/corretor/leads',
      icon: <img src={homeIcon} />
    },
    {
      title: 'Gerencie seus perfis',
      id: 2,
      isBeta: true,
      url: '/corretor/leads/perfis',
      icon: <img src={profileIcon} />
    },
    {
      title: 'Gerencie suas equipes',
      id: 3,
      isBeta: true,
      url: '/corretor/leads/equipes',
      icon: <img src={peoplesIcon} />
    },
    {
      title: 'Configurações',
      id: 4,
      url: '/corretor/leads/configuracoes',
      icon: <img src={configsIcon} />
    },
    {
      title: 'Sair',
      id: 5,
      url: '/corretor',
      icon: <img src={logoutIcon} />
    }
  ];

  const subItems = [
    {
      description: 'Criar equipe',
      icon: null,
      id: 6,
      title: '',
      url: '/corretor/leads/equipes/cadastro-equipe'
    },
    {
      description: 'Vincular novo vendedor',
      icon: null,
      id: 7,
      title: '',
      url: '/corretor/leads/perfis/cadastro'
    },
    {
      description: 'Alterar equipe',
      icon: null,
      id: 8,
      title: '',
      url: '/corretor/leads/equipes/alterar-equipe'
    },
    {
      description: 'Visão geral',
      icon: null,
      id: 9,
      title: '',
      url: '/corretor/leads/listagem'
    }
  ];

  const selectedItem = items.find((item) => location.pathname === item.url);
  const selectedSubItem = subItems.find(
    (subItem) => location.pathname === subItem.url
  );

  const getSubHeaderTitle = () => {
    if (selectedItem) {
      return selectedItem?.description ?? selectedItem?.title;
    } else {
      return selectedSubItem?.description ?? selectedSubItem?.title;
    }
  };

  const isHomeLeads =
    location.pathname === '/corretor/leads' ||
    location.pathname === '/corretor/leads/gestao';

  return (
    <div className={classes} {...rest}>
      <div className="tw-hidden md:tw-flex">
        <NavigationBar items={items} title="Painel Gestão de Leads" />
      </div>

      <div className="tw-flex-1">
        <PageSubHeaderLeads
          title={getSubHeaderTitle()}
          isBeta={selectedItem?.isBeta ?? false}
          isGestor={true}
        />

        {
          <div className="tw-bg-[#f4f4f4] md:tw-px-14 tw-py-[1.88rem]">
            {isHomeLeads ? (
              children
            ) : (
              <>
                <BackLink /> <div className="tw-px-[1rem]">{children}</div>
              </>
            )}
          </div>
        }
      </div>
    </div>
  );
};
